(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-a-box-main"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var productSwiper = new Swiper('.products-slider', {
      slidesPerView: 1,
      spaceBetween: 50,
      loop: true,
      autoHeight: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 100,
        },
      },
    });
    var testimonialSwiper = new Swiper('.build-testimonials', {
      slidesPerView: 1,
      spaceBetween: 50,
      loop: true,
      autoHeight: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 100,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-gift-main-popups"]) return;
  try {
    
  var swiper = new Swiper('.swiper-thumbs', {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6,
      },
    },
  });
  var swiper2 = new Swiper('.swiper-main', {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="box-frequency"]');

  function updateCheckoutButton() {
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedFrequency = document.querySelector('input[name="box-frequency"]:checked').id;
    const onePrice = document.querySelector('.frequency input[type="radio"]#one + label .price');
    const fourPrice = document.querySelector('.frequency input[type="radio"]#four + label .price');
    const savings = document.querySelector('.frequency input[type="radio"]#four + label .savings');
    // const billedAnnually = document.querySelector('.frequency input[type="radio"]#four + label .billed-annually')

    const config = productConfigs[selectedBoxType][selectedFrequency];
    console.log(config);
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    onePrice.innerHTML = '$' + productConfigs[selectedBoxType].one.price + '<span> / box</span>';
    fourPrice.innerHTML =
      '$' + parseFloat(productConfigs[selectedBoxType].four.price / 4.0).toFixed(2) + '<span> / box</span>';
    // billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].four.price) + ' annually.';
    savings.innerText =
      '$' + (productConfigs[selectedBoxType].one.price * 4 - productConfigs[selectedBoxType].four.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `Add to Cart - $${price} ${lockIcon}`;

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (
      !checkoutButton.classList.contains('is-sticky') &&
      window.scrollY > checkoutButton.offsetTop + checkoutButton.offsetHeight
    ) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }

  window.addEventListener('scroll', updateButtonPosition);

  updateButtonPosition();
  updateCheckoutButton();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-gift-main"]) return;
  try {
    
  var swiper = new Swiper('.swiper-thumbs', {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6,
      },
    },
  });
  var swiper2 = new Swiper('.swiper-main', {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="box-frequency"]');

  function updateCheckoutButton() {
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedFrequency = document.querySelector('input[name="box-frequency"]:checked').id;
    const onePrice = document.querySelector('.frequency input[type="radio"]#one + label .price');
    const fourPrice = document.querySelector('.frequency input[type="radio"]#four + label .price');
    const savings = document.querySelector('.frequency input[type="radio"]#four + label .savings');
    // const billedAnnually = document.querySelector('.frequency input[type="radio"]#four + label .billed-annually')

    const config = productConfigs[selectedBoxType][selectedFrequency];
    console.log(config);
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    onePrice.innerHTML = '$' + productConfigs[selectedBoxType].one.price + '<span> / box</span>';
    fourPrice.innerHTML =
      '$' + parseFloat(productConfigs[selectedBoxType].four.price / 4.0).toFixed(2) + '<span> / box</span>';
    // billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].four.price) + ' annually.';
    savings.innerText =
      '$' + (productConfigs[selectedBoxType].one.price * 4 - productConfigs[selectedBoxType].four.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `Add to Cart - $${price} ${lockIcon}`;

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (
      !checkoutButton.classList.contains('is-sticky') &&
      window.scrollY > checkoutButton.offsetTop + checkoutButton.offsetHeight
    ) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }

  window.addEventListener('scroll', updateButtonPosition);

  updateButtonPosition();
  updateCheckoutButton();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-consolidated-main"] && !window.DesignMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const frequencyInputs = document.querySelectorAll('input[name="box-frequency"]');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedFrequency = document.querySelector('input[name="box-frequency"]:checked').id;
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually');
    const planTitles = document.querySelectorAll('.plan input[type="radio"] + label .plan-title');
    const planDescriptions = document.querySelectorAll('.plan input[type="radio"] + label .plan-description');
    const seasonalBilling = document.querySelector('.plan input[type="radio"]#seasonal + label p:not(.plan-description)');

    // Update plan labels based on frequency
    if (selectedFrequency === 'onetime') {
      planTitles[0].textContent = '4 Boxes';
      planTitles[1].textContent = 'Single Box';
      planDescriptions[0].textContent = 'Prepay for 4 boxes';
      planDescriptions[1].textContent = 'One-time purchase';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed once.';
      }
      if (seasonalBilling) {
        seasonalBilling.innerText = 'Billed once.';
      }
    } else {
      planTitles[0].textContent = 'Annual';
      planTitles[1].textContent = 'Seasonal';
      planDescriptions[0].textContent = 'Prepay for 4 boxes & save';
      planDescriptions[1].textContent = 'Pay Per box';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed annually.';
      }
      if (seasonalBilling) {
        seasonalBilling.innerText = 'Billed quarterly.';
      }
    }

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    if (selectedBoxType == 'regular') {
      bullets.forEach((bullet) => {
        bullet.textContent = bullet.textContent.replace('4-8', '1-3');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'none';
        }
      });
    } else {
      bullets.forEach((bullet) => {
        bullet.textContent = bullet.textContent.replace('1-3', '4-8');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'block';
        }
      });
    }
    
    var consolidatedPlan = selectedPlan;
    if (selectedFrequency === 'onetime') {
      if (selectedPlan === 'seasonal') {
        consolidatedPlan = 'single'
      } else {
        consolidatedPlan = 'four'
      }
    } else {
      consolidatedPlan = selectedPlan;
    }

    const config = productConfigs[selectedBoxType][consolidatedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    if (selectedFrequency === 'onetime') {
      seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].single.price + '<span> / box</span>';
      annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].four.price / 4.00).toFixed(2) + '<span> / box</span>';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].four.price) + ' once.';
      }
      if (savings) {
        savings.innerText = '$' + (productConfigs[selectedBoxType].single.price * 4 - productConfigs[selectedBoxType].four.price);
      }
    } else {
      seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].seasonal.price + '<span> / box</span>';
      annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
      }
      if (savings) {
        savings.innerText = '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);
      }
    }

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;

    frequencyInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    })

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-main-checkout"]) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually')

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    if (selectedBoxType == 'regular') {
      bullets.forEach((bullet) => {
        bullet.textContent = bullet.textContent.replace('4-8', '1-3');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'none';
        }
      });
    } else {
      bullets.forEach((bullet) => {
        bullet.textContent = bullet.textContent.replace('1-3', '4-8');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'block';
        }
      });
    }

    const config = productConfigs[selectedBoxType][selectedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].seasonal.price + '<span> / box</span>';
    annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
    billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
    savings.innerText =
      '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-main-gilt"]) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually')

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    if (selectedBoxType == 'regular') {
      bullets.forEach((bullet) => {
        bullet.textContent = bullet.textContent.replace('4-8', '1-3');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'none';
        }
      });
    } else {
      bullets.forEach((bullet) => {
        bullet.textContent = bullet.textContent.replace('1-3', '4-8');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'block';
        }
      });
    }

    const config = productConfigs[selectedBoxType][selectedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].seasonal.price + '<span> / box</span>';
    annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
    billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
    savings.innerText =
      '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    // checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;
    checkoutButton.innerHTML = `${ctaText} ${lockIcon}`;

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-main-popup"] && !window.DesignMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually')

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    if (selectedBoxType == 'regular') {
      bullets.forEach((bullet) => {
        bullet.textContent = bullet.textContent.replace('4-8', '1-3');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'none';
        }
      });
    } else {
      bullets.forEach((bullet) => {
        bullet.textContent = bullet.textContent.replace('1-3', '4-8');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'block';
        }
      });
    }

    const config = productConfigs[selectedBoxType][selectedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].seasonal.price + '<span> / box</span>';
    annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
    billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
    savings.innerText =
      '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-main-winback"] && !window.DesignMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually')

    const savingsPercent = Math.round(
      ((productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price) /
      (productConfigs[selectedBoxType].seasonal.price * 4)) * 100
    );
    const roundedSavings = Math.round(savingsPercent / 5) * 5;

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    bullets.forEach((bullet) => {
      if (selectedBoxType === 'regular') {
        bullet.innerHTML = bullet.innerHTML.replace('4-8', '1-3');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'none';
        }
      } else {
        bullet.innerHTML = bullet.innerHTML.replace('1-3', '4-8');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'block';
        }
      }

      if (bullet.hasAttribute('data-dynamic-savings')) {
        bullet.innerHTML = bullet.innerHTML.replace(/\d+%/, `${roundedSavings}%`);
      }
    });


    const config = productConfigs[selectedBoxType][selectedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    seasonalPrice.innerHTML = '<s>$169</s> $' + parseInt(productConfigs[selectedBoxType].seasonal.price) + '<span> / box</span>';
    annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
    billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
    savings.innerText =
      '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-pdp-main"] && !window.DesignMode) return;
  try {
    
  var swiper = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    breakpoints: {
      768: {
        slidesPerView: 6
      }
    }
  });
  var swiper2 = new Swiper(".swiper-main", {
    zoom: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  const checkoutButton = document.querySelector('.checkout-button');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually')

    const savingsPercent = Math.round(
      ((productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price) /
      (productConfigs[selectedBoxType].seasonal.price * 4)) * 100
    );
    const roundedSavings = Math.round(savingsPercent / 5) * 5;

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
    bullets.forEach((bullet) => {
      if (selectedBoxType === 'regular') {
        bullet.innerHTML = bullet.innerHTML.replace('4-8', '1-3');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'none';
        }
      } else {
        bullet.innerHTML = bullet.innerHTML.replace('1-3', '4-8');
        if (bullet.classList.contains('hide-lite')) {
          bullet.style.display = 'block';
        }
      }

      if (bullet.hasAttribute('data-dynamic-savings')) {
        bullet.innerHTML = bullet.innerHTML.replace(/\d+%/, `${roundedSavings}%`);
      }
    });


    const config = productConfigs[selectedBoxType][selectedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].seasonal.price + '<span> / box</span>';
    annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
    billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
    savings.innerText =
      '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }
  
  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-testimonials"]) return;
  try {
     
    var swiper = new Swiper(".swiper-testimonials", {
        slidesPerView: 1,
        spaceBetween: 100,
        loop: true,
        autoHeight: true,
        navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 3
            },
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-verified-unboxings"]) return;
  try {
     
    const swiperConfig = {
        slidesPerView: 'auto',
        spaceBetween: 8,
        loop: true,
        loopedSlides: 8,
        freeMode: {
            enabled: true,
            momentum: false
        },
        slidesOffsetBefore: -25,
        speed: 5000,
        breakpoints: {
            768: {
                spaceBetween: 16
            }
        }
    };

    var topSwiper = new Swiper(".swiper-unboxings-top", swiperConfig);
    var bottomSwiper = new Swiper(".swiper-unboxings-bottom", {
        ...swiperConfig,
        slidesOffsetBefore: -50,
        breakpoints: {
            768: {
                spaceBetween: 16,
                slidesOffsetBefore: -125
            }
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-pdp-main-steps"] && !window.DesignMode) return;
  try {
    
  const checkoutButton = document.querySelector('.checkout-button');
  const frequencyInputs = document.querySelectorAll('input[name="box-frequency"]');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedFrequency = document.querySelector('input[name="box-frequency"]:checked').id;
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually');
    const planTitles = document.querySelectorAll('.plan input[type="radio"] + label .plan-title');
    const planDescriptions = document.querySelectorAll('.plan input[type="radio"] + label .plan-description');
    const seasonalBilling = document.querySelector('.plan input[type="radio"]#seasonal + label p:not(.plan-description)');

    // Update plan labels based on frequency
    if (selectedFrequency === 'onetime') {
      planTitles[0].textContent = '4 Boxes';
      planTitles[1].textContent = 'Single Box';
      planDescriptions[0].textContent = 'Prepay for 4 boxes';
      planDescriptions[1].textContent = 'One-time purchase';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed once.';
      }
      if (seasonalBilling) {
        seasonalBilling.innerText = 'Billed once.';
      }
    } else {
      planTitles[0].textContent = 'Annual';
      planTitles[1].textContent = 'Seasonal';
      planDescriptions[0].textContent = 'Prepay for 4 boxes & save';
      planDescriptions[1].textContent = 'Pay Per box';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed annually.';
      }
      if (seasonalBilling) {
        seasonalBilling.innerText = 'Billed quarterly.';
      }
    }

      const savingsPercent = Math.round(
          ((productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price) /
          (productConfigs[selectedBoxType].seasonal.price * 4)) * 100
      );
      const roundedSavings = Math.round(savingsPercent / 5) * 5;

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
      bullets.forEach((bullet) => {
        if (selectedBoxType === 'regular') {
          bullet.innerHTML = bullet.innerHTML.replace('4-8', '1-3');
          if (bullet.classList.contains('hide-lite')) {
              bullet.style.display = 'none';
          }
        } else {
            bullet.innerHTML = bullet.innerHTML.replace('1-3', '4-8');
                if (bullet.classList.contains('hide-lite')) {
                bullet.style.display = 'block';
            }
        }

        if (bullet.hasAttribute('data-dynamic-savings')) {
            bullet.innerHTML = bullet.innerHTML.replace(/\d+%/, `${roundedSavings}%`);
        }
    });

    var consolidatedPlan = selectedPlan;
    if (selectedFrequency === 'onetime') {
      if (selectedPlan === 'seasonal') {
        consolidatedPlan = 'single'
      } else {
        consolidatedPlan = 'four'
      }
    } else {
      consolidatedPlan = selectedPlan;
    }

    const config = productConfigs[selectedBoxType][consolidatedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    if (selectedFrequency === 'onetime') {
      seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].single.price + '<span> / box</span>';
      annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].four.price / 4.00).toFixed(2) + '<span> / box</span>';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].four.price) + ' once.';
      }
      if (savings) {
        savings.innerText = '$' + (productConfigs[selectedBoxType].single.price * 4 - productConfigs[selectedBoxType].four.price);
      }
    } else {
      seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].seasonal.price + '<span> / box</span>';
      annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
      }
      if (savings) {
        savings.innerText = '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);
      }
    }

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;

    frequencyInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    })

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });
  }

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight)) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }

  window.addEventListener('scroll', updateButtonPosition)

  updateButtonPosition();
  updateCheckoutButton();

  function showStep(stepToShow, stepToHide, event) {
    event.preventDefault();
    stepToShow.style.display = "block";
    setTimeout(() => stepToShow.classList.add('active'), 500);

    if (stepToShow === stepOne) {
      document.querySelector('.step-one').classList.add('active');
    } else {
      document.querySelector('.step-two').classList.add('active');
    }

    stepToHide.classList.remove('active');
    
    setTimeout(() => {
      stepToShow.classList.add('active');
    }, 50);
  }

  const stepOne = document.querySelector('.step-one');
  const stepTwo = document.querySelector('.step-two');

  const nextBtn = document.querySelector('.btn-next');
  const prevBtn = document.querySelector('.btn-prev');

  nextBtn.addEventListener('click', (event) => showStep(stepTwo, stepOne, event));
  prevBtn.addEventListener('click', (event) => showStep(stepOne, stepTwo, event));

  const modal = document.getElementById('modal');
  const modalBody = document.getElementById('modal-body');
  const modalBtn = document.getElementById('open-modal');
  const closeModal = document.getElementById('close-button');

  modalBtn.addEventListener('click', () => {
    modalBody.innerHTML = `
      <div class="loader"></div>
      <p style="text-align:center;">Loading content...</p>
    `;
    modal.style.display = "block";
    
    fetch(nowShippingModalLink)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const targetDiv = doc.querySelector('main.main-content');

        modalBody.innerHTML = targetDiv ? targetDiv.innerHTML : "<p style='text-align:center;'>Content not found</p>";
      })
      .catch(() => {
        modalBody.innerHTML = "<p style='color:red; text-align:center;'>Failed to load content.</p>";
      })
  });

  closeModal.addEventListener('click', () => {
    modal.style.display = 'none';
  });

  window.addEventListener('click', (event) => {
    if (event.target === modal) {
      modal.style.display = 'none';
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-pdp-main"] && !window.DesignMode) return;
  try {
    
  const checkoutButton = document.querySelector('.checkout-button');
  const frequencyInputs = document.querySelectorAll('input[name="box-frequency"]');
  const boxTypeInputs = document.querySelectorAll('input[name="box-type"]');
  const planInputs = document.querySelectorAll('input[name="seasonal-annual"]');

  function updateCheckoutButton() {
    const selectedFrequency = document.querySelector('input[name="box-frequency"]:checked').id;
    const selectedBoxType = document.querySelector('input[name="box-type"]:checked').id;
    const selectedPlan = document.querySelector('input[name="seasonal-annual"]:checked').id;
    const seasonalPrice = document.querySelector('.plan input[type="radio"]#seasonal + label .price');
    const annualPrice = document.querySelector('.plan input[type="radio"]#annual + label .price');
    const savings = document.querySelector('.plan input[type="radio"]#annual + label .savings');
    const billedAnnually = document.querySelector('.plan input[type="radio"]#annual + label .billed-annually');
    const planTitles = document.querySelectorAll('.plan input[type="radio"] + label .plan-title');
    const planDescriptions = document.querySelectorAll('.plan input[type="radio"] + label .plan-description');
    const seasonalBilling = document.querySelector('.plan input[type="radio"]#seasonal + label p:not(.plan-description)');

    // Update plan labels based on frequency
    if (selectedFrequency === 'onetime') {
      planTitles[0].textContent = '4 Boxes';
      planTitles[1].textContent = 'Single Box';
      planDescriptions[0].textContent = 'Prepay for 4 boxes';
      planDescriptions[1].textContent = 'One-time purchase';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed once.';
      }
      if (seasonalBilling) {
        seasonalBilling.innerText = 'Billed once.';
      }
    } else {
      planTitles[0].textContent = 'Annual';
      planTitles[1].textContent = 'Seasonal';
      planDescriptions[0].textContent = 'Prepay for 4 boxes & save';
      planDescriptions[1].textContent = 'Pay Per box';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed annually.';
      }
      if (seasonalBilling) {
        seasonalBilling.innerText = 'Billed quarterly.';
      }
    }

      const savingsPercent = Math.round(
          ((productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price) /
          (productConfigs[selectedBoxType].seasonal.price * 4)) * 100
      );
      const roundedSavings = Math.round(savingsPercent / 5) * 5;

    const bullets = document.querySelectorAll('.plan input[type="radio"] + label ul li');
      bullets.forEach((bullet) => {
        if (selectedBoxType === 'regular') {
          bullet.innerHTML = bullet.innerHTML.replace('4-8', '1-3');
          if (bullet.classList.contains('hide-lite')) {
              bullet.style.display = 'none';
          }
        } else {
            bullet.innerHTML = bullet.innerHTML.replace('1-3', '4-8');
                if (bullet.classList.contains('hide-lite')) {
                bullet.style.display = 'block';
            }
        }

        if (bullet.hasAttribute('data-dynamic-savings')) {
            bullet.innerHTML = bullet.innerHTML.replace(/\d+%/, `${roundedSavings}%`);
        }
    });

    var consolidatedPlan = selectedPlan;
    if (selectedFrequency === 'onetime') {
      if (selectedPlan === 'seasonal') {
        consolidatedPlan = 'single'
      } else {
        consolidatedPlan = 'four'
      }
    } else {
      consolidatedPlan = selectedPlan;
    }

    const config = productConfigs[selectedBoxType][consolidatedPlan];
    checkoutButton.setAttribute('data-variant-id', config.variantId);
    checkoutButton.setAttribute('data-selling-plan-id', config.sellingPlanId);

    const price = config.price;

    if (selectedFrequency === 'onetime') {
      seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].single.price + '<span> / box</span>';
      annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].four.price / 4.00).toFixed(2) + '<span> / box</span>';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].four.price) + ' once.';
      }
      if (savings) {
        savings.innerText = '$' + (productConfigs[selectedBoxType].single.price * 4 - productConfigs[selectedBoxType].four.price);
      }
    } else {
      seasonalPrice.innerHTML = '$' + productConfigs[selectedBoxType].seasonal.price + '<span> / box</span>';
      annualPrice.innerHTML = '$' + parseFloat(productConfigs[selectedBoxType].annual.price / 4.00).toFixed(2) + '<span> / box</span>';
      if (billedAnnually) {
        billedAnnually.innerText = 'Billed $' + parseInt(productConfigs[selectedBoxType].annual.price) + ' annually.';
      }
      if (savings) {
        savings.innerText = '$' + (productConfigs[selectedBoxType].seasonal.price * 4 - productConfigs[selectedBoxType].annual.price);
      }
    }

    const lockIcon = `<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7081 6.55984H10.4298V5.19401C10.4298 2.66798 8.51864 0.557696 6.13 0.512627C6.06484 0.511416 5.93437 0.511416 5.86921 0.512627C3.48041 0.557696 1.56944 2.66798 1.56944 5.19395V6.55979H1.29112C0.862459 6.55979 0.512695 7.02385 0.512695 7.59704V14.4473C0.512695 15.0197 0.862459 15.4881 1.29112 15.4881H10.708C11.1367 15.4881 11.4865 15.0197 11.4865 14.4473V7.59704C11.4865 7.02391 11.1367 6.55979 10.708 6.55979L10.7081 6.55984ZM6.88183 11.0152V13.085C6.88183 13.3221 6.69265 13.5225 6.46649 13.5225H5.53277C5.30661 13.5225 5.11743 13.3221 5.11743 13.085V11.0152C4.89814 10.7886 4.7704 10.4755 4.7704 10.1292C4.7704 9.47279 5.2541 8.90862 5.86926 8.88265C5.93442 8.87979 6.0649 8.87979 6.13005 8.88265C6.74527 8.90862 7.22892 9.47279 7.22892 10.1292C7.22892 10.4755 7.10117 10.7886 6.88188 11.0152H6.88183ZM8.59613 6.55984H3.40303V5.19401C3.40303 3.68933 4.56879 2.44505 5.99953 2.44505C7.43027 2.44505 8.59613 3.68933 8.59613 5.19401V6.55984Z" fill="white"/>
    </svg>`;
    checkoutButton.innerHTML = `${ctaText} - $${price} ${lockIcon}`;
  }

  frequencyInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    })

    boxTypeInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

    planInputs.forEach((input) => {
      input.addEventListener('change', updateCheckoutButton);
    });

  function updateButtonPosition() {
    const subscriptionsRect = document.querySelector('.subscriptions').getBoundingClientRect();
    if (!checkoutButton.classList.contains('is-sticky') && window.scrollY > (checkoutButton.offsetTop + checkoutButton.offsetHeight) && subscriptionsRect.bottom <= 0) {
      checkoutButton.classList.add('is-sticky');
    } else if (subscriptionsRect.bottom > 0) {
      checkoutButton.classList.remove('is-sticky');
    }
  }

  window.addEventListener('scroll', updateButtonPosition)

  // updateButtonPosition();
  // updateCheckoutButton();

  const modal = document.getElementById('modal');
  const modalBody = document.getElementById('modal-body');
  const modalBtn = document.getElementById('open-modal');
  const closeModal = document.getElementById('close-button');

  modalBtn.addEventListener('click', () => {
    document.querySelector('body').style.overflow = 'hidden';
    modalBody.innerHTML = `
      <div class="loader"></div>
      <p style="text-align:center;">Loading content...</p>
    `;
    modal.style.display = "block";
    
    fetch(nowShippingModalLink)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const targetDiv = doc.querySelector('main.main-content');

        modalBody.innerHTML = targetDiv ? targetDiv.innerHTML : "<p style='text-align:center;'>Content not found</p>";
      })
      .catch(() => {
        modalBody.innerHTML = "<p style='color:red; text-align:center;'>Failed to load content.</p>";
      })
  });

  closeModal.addEventListener('click', () => {
    document.querySelector('body').style.overflow = 'auto';
    modal.style.display = 'none';
  });

  window.addEventListener('click', (event) => {
    if (event.target === modal) {
      document.querySelector('body').style.overflow = 'auto';
      modal.style.display = 'none';
    }
  });

  function goToStep(stepNumber) {
    const currentStep = document.querySelector('.step.active');

    if (currentStep) {
      currentStep.classList.add('fade-out');
      setTimeout(() => {
        currentStep.classList.remove('active', 'fade-out');
        document.getElementById(`step-${stepNumber}`).classList.add('active');
      }, 300)
    } else {
      document.getElementById(`step-${stepNumber}`).classList.add('active');
    }
  }

  window.goToStep = goToStep;

  document.querySelectorAll('.frequency input').forEach((input) => {
    input.addEventListener('change', function() {
      if (this.checked) {
        goToStep(2);
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz"]) return;
  try {
    
    const quizContainer = document.querySelector('.quiz-container');
    const steps = document.querySelectorAll('.step');
    const progressBar = document.querySelector('.progress');
    const result = document.querySelector('.result');
    const answersSummary = document.getElementById('answers-summary');
    let currentStep = 1;
    const totalSteps = steps.length;
    const answers = {};

    // Initialize progress bar
    updateProgress();

    // Add click event for options
    document.querySelectorAll('.option').forEach(option => {
        option.addEventListener('click', function() {
            const stepElement = this.closest('.step');
            const radioInput = this.querySelector('input[type="radio"]');
                    
            // Deselect all options in current step
            stepElement.querySelectorAll('.option').forEach(opt => {
                opt.classList.remove('selected');
            });
                    
            // Select clicked option
            this.classList.add('selected');
            radioInput.checked = true;
                    
            // Enable next button
            stepElement.querySelector('.next-btn').disabled = false;
        });
    });

    // Add click event for next buttons
    document.querySelectorAll('.next-btn').forEach(button => {
        button.addEventListener('click', function() {
            const currentStepElement = this.closest('.step');
            const isTextOnly = currentStepElement.getAttribute('data-text-only') === 'true';
                    
            if (!isTextOnly) {
                const selectedOption = currentStepElement.querySelector('input[type="radio"]:checked');
                        
                if (selectedOption) {
                    answers[`q${currentStep}`] = selectedOption.value;                    
                }
            }
                    
            if (currentStep < totalSteps) {
                currentStep++;
                updateStep();
            } else {
                showResult();
            }
        });
    });

    // Add click event for the universal previous button
    const universalPrevBtn = document.getElementById('universal-prev-btn');
    universalPrevBtn.addEventListener('click', function() {
        if (currentStep > 1) {
            currentStep--;
            updateStep();
        }
    });

    document.querySelector('.restart-btn').addEventListener('click', function() {
        document.querySelectorAll('input[type="radio"]').forEach(input => {
            input.checked = false;
        });
        document.querySelectorAll('.option').forEach(option => {
            option.classList.remove('selected');
        });
                
        currentStep = 1;
        updateStep();
                
        Object.keys(answers).forEach(key => delete answers[key]);
                
        result.style.display = 'none';
                
        steps[0].classList.add('active');
                
        updateProgress();
    });

    function updateStep() {
        steps.forEach(step => {
            step.classList.remove('active');
        });
        document.querySelector(`[data-step="${currentStep}"]`).classList.add('active');
                
        updateProgress();
                
        // Show or hide the universal previous button
        if (currentStep === 1) {
            universalPrevBtn.style.display = 'none';
        } else {
            universalPrevBtn.style.display = 'block';
        }
        const nextBtn = document.querySelector('.step.active .next-btn');
        const isTextOnly = document.querySelector(`[data-step="${currentStep}"]`).getAttribute('data-text-only') === 'true';
        if (isTextOnly) {
            nextBtn.disabled = false;
        } else {
            nextBtn.disabled = !document.querySelector(`.step.active input[name="q${currentStep}"]:checked`);
        }
    }

    function updateProgress() {
        const progress = ((currentStep - 1) / totalSteps) * 100;
        progressBar.style.width = `${progress}%`;
    }

    function showResult() {
        steps.forEach(step => step.classList.remove('active'));
        result.style.display = 'block';
        
        progressBar.style.width = '100%';
        
        const summary = document.createElement('div');
        summary.style.marginBottom = '20px';
        summary.style.textAlign = 'left';
                
        Object.entries(answers).forEach(([question, answer]) => {
            const p = document.createElement('p');
            p.style.margin = '10px 0';
            p.style.color = '#666';
            p.textContent = `Question ${question.slice(1)}: ${answer}`;
            summary.appendChild(p);
        });
                
        answersSummary.innerHTML = '';
        answersSummary.appendChild(summary);
    }

  } catch(e) { console.error(e); }
})();
})();
